import Banner from "./Banner";
import Eventsection from "./Eventsection";

const Events = ({ language }) => {
  return (
    <>
      <Banner language={language} />
      <Eventsection language={language} />
    </>
  );
};

export default Events;